import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Cliente } from 'src/app/entidades/cliente';
import { DefinicaoColuna } from 'src/app/entidades/definicaoColuna';
import { Pagina } from 'src/app/entidades/pagina';
import { Parametros } from 'src/app/entidades/parametro';
import { PermissaoCotar } from 'src/app/entidades/permissaoCotar';
import { Status } from 'src/app/entidades/status';
import { FiltroCliente } from 'src/app/enum/filtroCliente';
import { enumToArray } from 'src/app/helper/enumToArray';
import { ApiService } from 'src/app/services/api/api.service';
import { ClienteService } from 'src/app/services/cliente/cliente.service';
import { MensagemService } from 'src/app/services/mensagem/mensagem.service';
import { PermissaoCotarService } from 'src/app/services/permissao-cotar/permissao-cotar.service';
import { PesquisaService } from 'src/app/services/pesquisa/pesquisa.service';
import { StatusService } from 'src/app/services/status/status.service';
import { DialogoComponent } from '../dialogo/dialogo/dialogo.component';
import { PermissaoCotarComponent } from '../permissao-cotar/permissao-cotar.component';

@Component({
  selector: 'app-parametros',
  templateUrl: './parametros.component.html',
  styleUrls: ['./parametros.component.css', '../../app.component.css']
})
export class ParametrosComponent implements OnInit {
  isBusy = false;
  formulario: FormGroup;
  editando = false;
  titulo: string;
  clientes: Cliente[];
  status: Status[];
  statusFiltrados: Status[];
  statusFinaliza: Status[];
  statusFinalizaFiltrados: Status[];
  permissoesCotar: PermissaoCotar[];
  dataSource: MatTableDataSource<PermissaoCotar>;
  paSelecionado: string;
  permissaoSelecionada: PermissaoCotar;
  paginator = {
    length: 0,
    pageIndex: 0,
    pageSize: 25,
    previousPageIndex: 0
  };
  pagina: Pagina<PermissaoCotar>;
  qtdeRegistros: number;
  displayedColumns: string[] = ['codPA', 'dataPermissao', 'acoes'];
  private subscriptions = new Subscription();

  constructor(private apiService: ApiService,
    private formBuilder: FormBuilder,
    private clienteService: ClienteService,
    private pesquisaService: PesquisaService,
    private statusService: StatusService,
    private dialog: MatDialog,
    private mensagemService: MensagemService,
    private router: Router,
    private permissaoCotarService: PermissaoCotarService) { }

  async ngOnInit(): Promise<void> {
    this.dataSource = new MatTableDataSource<PermissaoCotar>();
    this.titulo = 'Cadastro de Parâmetros';
    this.criarFormulario();
    await this.obterListas();
    this.popularFormulario();
    this.pesquisaService.resultadoEmitter.subscribe((res: Cliente) => {
      this.adicionarCooperado(res);
    });
  }

  adicionarCooperado(cooperado: Cliente): void {
    let inputCooperado = document.getElementById('inputCooperado');
    if (inputCooperado !== null && inputCooperado !== undefined) {
      (<any>inputCooperado).value = cooperado.associado;
    }
    this.formulario.patchValue({
      clienteId: cooperado.id
    });
  }

  async obterListas(): Promise<void> {
    /* Clientes Obtém o primeiro Cliente para gerar as colunas da consulta */
    await this.clienteService.todos().then(res => {
      this.clientes = this.apiService.verificaSeResult<Cliente[]>(res);
    });
    /* Status */
    await this.statusService.todos().then(res => {
      this.status = this.apiService.verificaSeResult<Status[]>(res);
      this.statusFiltrados = this.status.slice();
      this.statusFinaliza = this.status.slice();
      this.statusFinalizaFiltrados = this.statusFinaliza.slice();
    });

    /* Permissão  para Cotar no PA */
    await this.permissaoCotarService.Obter(this.paginator).then(res => {
      let dados = this.apiService.verificaSeResult<Pagina<PermissaoCotar>>(res);
      this.configurarPagina(dados);
    });
  }

  async rowClick(row: PermissaoCotar): Promise<void> {
    if (row === null || row === undefined) return;
    this.permissaoSelecionada = row;
    this.paSelecionado = this.permissaoSelecionada?.codPA;
  }

  async configurarPagina(pagina: Pagina<PermissaoCotar>): Promise<void> {
    this.permissoesCotar = [];
    if (pagina !== null && pagina !== undefined) {
      this.permissoesCotar = pagina.dados as PermissaoCotar[];
    }
    // Atualiza os dados da instância existente ao invés de criar uma nova
    if (this.dataSource) {
      this.dataSource.data = this.permissoesCotar;
    } else {
      this.dataSource = new MatTableDataSource(this.permissoesCotar);
    }
    this.pagina = pagina;
    this.qtdeRegistros = this.pagina?.quantidadeRegistros;
  }

  criarFormulario() {
    this.formulario = this.formBuilder.group({
      id: [0],
      idClienteSemRegistro: [0, Validators.required],
      idStatusNovaCotacao: [null, Validators.required],
      qtdeChamadosAbertosPorAssessor: [null],
      qtdeClientesGeraVisita: [false, Validators.required],
      qtdeDiasAbrirCotacaoFutura: [0, Validators.required],
      diasLembreteParcelas: [0, Validators.required],
      pesquisaClienteAgendaPorCarteira: [false, Validators.required],
      habilitarComissionadoNaCotacao: [false, Validators.required],
      statusIdFinalizaChamado: [null, Validators.required],
      exibirCuponsPorAgrupamento: [false],
      idStatusCotarNoPA: [0, Validators.required],
      idStatusConferirNoPA: [0, Validators.required],
      idStatusPendenciaDoPA: [0, Validators.required],
      idStatusAguardandoRetornoPA: [0, Validators.required]
    });
  }

  popularFormulario() {
    this.formulario.patchValue({
      id: this.apiService.Parametros.id,
      idClienteSemRegistro: this.apiService.Parametros.idClienteSemRegistro,
      idStatusNovaCotacao: this.apiService.Parametros.idStatusNovaCotacao,
      qtdeChamadosAbertosPorAssessor: this.apiService.Parametros.qtdeChamadosAbertosPorAssessor,
      qtdeClientesGeraVisita: this.apiService.Parametros.qtdeClientesGeraVisita,
      qtdeDiasAbrirCotacaoFutura: this.apiService.Parametros.qtdeDiasAbrirCotacaoFutura,
      diasLembreteParcelas: this.apiService.Parametros.diasLembreteParcelas,
      pesquisaClienteAgendaPorCarteira: this.apiService.Parametros.pesquisaClienteAgendaPorCarteira,
      habilitarComissionadoNaCotacao: this.apiService.Parametros.habilitarComissionadoNaCotacao,
      statusIdFinalizaChamado: this.apiService.Parametros.statusIdFinalizaChamado,
      exibirCuponsPorAgrupamento: this.apiService.Parametros.exibirCuponsPorAgrupamento,
      idStatusCotarNoPA: this.apiService.Parametros.idStatusCotarNoPA,
      idStatusConferirNoPA: this.apiService.Parametros.idStatusConferirNoPA,
      idStatusPendenciaDoPA: this.apiService.Parametros.idStatusPendenciaDoPA,
      idStatusAguardandoRetornoPA: this.apiService.Parametros.idStatusAguardandoRetornoPA
    });
    this.formulario.markAsPristine();
    let semRegistro = this.clientes.find(x => x.id === this.apiService.Parametros.idClienteSemRegistro);
    let inputCooperado = document.getElementById('inputCooperado');
    if (inputCooperado !== null && inputCooperado !== undefined) {
      (<any>inputCooperado).value = semRegistro.associado;
    }
  }

  async pesquisaCooperado(): Promise<void> {
    const definicaoColunas: DefinicaoColuna[] = [
      { definicao: 'id', exibicao: 'Id' },
      { definicao: 'associado', exibicao: 'Nome' },
      { definicao: 'cpF_CNPJ', exibicao: 'CPF / CNPJ' },
      { definicao: 'conta', exibicao: 'Conta' }
    ];
    const colunas = [{
      id: this.clientes[0].id,
      associado: this.clientes[0].associado,
      cpF_CNPJ: this.clientes[0].cpF_CNPJ,
      conta: this.clientes[0].conta
    }]
    this.pesquisaService.pesquisaEventEmitter.emit(true);
    this.pesquisaService.tituloEventEmitter.emit('Obter Cooperado');
    this.pesquisaService.mensagemEventEmitter.emit('Selecione o Cooperado desejado');
    this.pesquisaService.colunasEmitter.emit(colunas);
    this.pesquisaService.functionEmitter.emit(this.clienteService.obter);
    this.pesquisaService.entidadeServiceEmitter.emit(this.clienteService);
    this.pesquisaService.filtrosEmitter.emit(enumToArray(FiltroCliente));
    this.pesquisaService.filtroEmitter.emit(this.clienteService.filtroClienteEmitter);
    this.pesquisaService.descricaoFEmitter.emit(this.clienteService.descricaoFiltroEmitter);
    this.pesquisaService.columnsHeadersEmitter.emit(definicaoColunas);
  }

  async onSubmit(): Promise<void> {
    let parametros = this.formulario.value as Parametros;
    await this.apiService.adicionarOuEditarParametros(parametros).then(async result => {
      if (!result) {
        await this.mensagemService.showMessage('Não foi possível atualizar os Parâmetros.', 'Ok', 5000, 'error');
      } else {
        await this.mensagemService.showMessage('Parâmetros alterados com sucesso.', 'Ok', 5000, 'success');
        this.popularFormulario();
      }
    });
  }

  cancelar(): void {
    this.router.navigate(['/']);
  }

  addPermissao(): void {
    const dialogConfig = new MatDialogConfig();        
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    let titulo = `Informe o PA  que que terá permissão para Cotar.`;
    let info = {
          titulo: titulo
        };
    dialogConfig.data = info;
    const dialogRef = this.dialog.open(PermissaoCotarComponent,dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
      if (result === 'Yes') {
        this.obterListas();
      }    
    });
  }

  async removerPermissao(row: PermissaoCotar): Promise<void> {
    const dialogRef = this.dialog.open(DialogoComponent, {
      data: {
        titulo: `Remoção  de Permissão de Cotar`,
        pergunta: `Confirma a remoção da permissão de cotar do ${row.codPA}?`,
      },
      width: '550px',
    });
     dialogRef.afterClosed().subscribe(async (result: string) => {
      if (result === 'yes') {
        await this.remover(row);
      }
    });    
  }

  async remover(row: PermissaoCotar): Promise<void> {
    await this.permissaoCotarService.RemoverPermissao(row.codPA).then(async result => {
      if (!result) {
        await this.mensagemService.showMessage(`Não foi possível remover a permissão de cotar do PA ${row.codPA}.`, 'Ok', 5000, 'error');
      } else {
        await this.mensagemService.showMessage('Permissão removida com sucesso.', 'Ok', 5000, 'success');
        this.obterListas();
      }
    });
  }
}
